import { render, staticRenderFns } from "./RecipientNoticeDetails.vue?vue&type=template&id=bad9e93e&scoped=true&"
import script from "./RecipientNoticeDetails.vue?vue&type=script&lang=js&"
export * from "./RecipientNoticeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad9e93e",
  null
  
)

export default component.exports